<template>
    <SectionBase
        v-if="section"
        ref="sectionRoot"
        :section="sectionShell"
        :class="sectionClasses"
        hide-background-image
    >
        <PortfolioNavigationBar
            :navigation="section"
        />
    </SectionBase>
</template>

<script>
import SectionBase from "@/scripts/view/portfolio/sections/SectionBase.vue";
import PortfolioNavigationBar from "@/scripts/view/portfolio/sections/common/navigation/PortfolioNavigationBar.vue";
import { NavigationPlacementEnum } from "@/scripts/common/enums.js";
import {createNavHeightObserver, setNavHeightVars} from "@/scripts/sections/common/navigation/navHeightObserver.js";
import navigationSectionBehaviorMixin from "@/scripts/sections/common/navigation/navigationSectionBehaviorMixin.js";
import {updateSectionLevelColorCssInHead} from "@/scripts/common/TextStyleRenderHelper.js";

export default {
    name: "PortfolioNavigationSection",
    mixins: [navigationSectionBehaviorMixin],
    components: { PortfolioNavigationBar, SectionBase },
    props: {
        section: {
            type: Object,
            default: null,
        },
    },
    data() {
        return {
            navHeightObserver: null,
        };
    },
    beforeMount() {
        if(!this.$route.query.templatePreview) {
            updateSectionLevelColorCssInHead(this.section)
        }
    },
    computed: {
        sectionShell() {
            return {
                type: "Navigation",
                layoutSettings: {
                    modules: [],
                },
            };
        },
        isOverlay() {
            return !this.$store.getters.heroIsSidebar
                && (this.$store.getters.isCaseStudy || this.section?.layout?.overlay === true);
        },
        isBelow() {
            return !this.$store.getters.isCaseStudy
                && !this.isPinnedEffect
                && this.isOverlay
                && this.section?.layout?.position === NavigationPlacementEnum.BOTTOM;
        },
        sectionClasses() {
            if (this.isOverlay) {
                return [
                    { "nav-overlay" : true },
                    { "nav-sticky" : this.isPinnedEffect },
                    this.isBelow ? "at-bottom" : null,
                ].filter(Boolean);
            }

            return null
        },
    },
    mounted() {
        this.navHeightObserver = createNavHeightObserver({
            isOverlay: () => this.isOverlay,
            getSectionEl: () => this.$refs.sectionRoot?.$el,
            onHeight: (height) => this.applyNavHeightVars(height),
            onClear: () => this.applyNavHeightVars(null),
        });
        this.$nextTick(() => {
            this.setupResizeObserver();
        });
    },
    beforeUnmount() {
        this.teardownResizeObserver();
    },
    watch: {
        isOverlay() {
            this.$nextTick(() => {
                this.setupResizeObserver();
            });
        },
        section() {
            this.$nextTick(() => {
                this.setupResizeObserver();
            });
        }
    },
    methods: {
        setupResizeObserver() {
            this.navHeightObserver?.setup();
        },
        teardownResizeObserver() {
            this.navHeightObserver?.teardown();
        },
        applyNavHeightVars(height) {
            setNavHeightVars({
                height,
                isBelow: this.isBelow,
                isOverlay: this.isOverlay,
            });
        },
    },
};
</script>
